<era-panel>
  <era-panel-header>
    <div class="border-bottom px-3 d-flex align-items-center py-2">
      Location:
      <strong class="ms-2 py-1">
        <era-select-location-list-devices></era-select-location-list-devices>
      </strong>
      @if (features.devices?.healthOverview) {
        <span class="ms-3">Category:</span>
        <strong class="ms-2 py-1">
          <era-device-category-type-filter [selected]="selectedCategoryTypes()"
                                           (selectedChange)="updateCategoryTypes($event)"></era-device-category-type-filter>
        </strong>
        <span class="ms-3">Device Health:</span>
        <strong class="ms-2 py-1">
          <era-device-health-state-filter [selected]="selectedHealthState()"
                                          (selectedChange)="updateHealthState($event)"></era-device-health-state-filter>
        </strong>
      }

      @if (features.devices?.reboot) {
        <div class="ms-auto flex-shrink-1 d-flex align-items-center">
          <era-context-menu>
            <button ngbDropdownItem
                    (click)="openRebootRequest()">Setup reboot</button>
            <button ngbDropdownItem
                    (click)="openSyncModalRequest()">Sync devices</button>
          </era-context-menu>
        </div>
      }
    </div>
  </era-panel-header>

  @if (features.devices.healthOverview && currentLocation(); as location) {
    <era-device-health-overview [location]="location"
                                [deviceCount]="currentLocationDevices().length"></era-device-health-overview>
  }

  @if (currentLocation()) {
    <era-master-detail flexGrowLeft="2"
                       flexGrowRight="1"
                       [isH2]="false">
      <era-master>
        <era-panel>
          <div class="px-3">
            @for (category of filteredDeviceCategories(); track category.type) {
              <era-devices-location-subset [config]="category"
                                           [healthState]="selectedHealthState()"></era-devices-location-subset>
            }
          </div>
        </era-panel>
      </era-master>
    </era-master-detail>
  }
</era-panel>